var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconionicIosCloseCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.045,
    height: 41.045,
    viewBox: "0 0 41.045 41.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M27.7,25.476l-5.2-5.2,5.2-5.2a1.577,1.577,0,1,0-2.23-2.23l-5.2,5.2-5.2-5.2a1.577,1.577,0,0,0-2.23,2.23l5.2,5.2-5.2,5.2a1.524,1.524,0,0,0,0,2.23,1.566,1.566,0,0,0,2.23,0l5.2-5.2,5.2,5.2a1.584,1.584,0,0,0,2.23,0A1.566,1.566,0,0,0,27.7,25.476Z",
    transform: "translate(3.623 3.621)",
    fill: "#9add3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M23.9,6.138a17.753,17.753,0,1,1-12.56,5.2,17.642,17.642,0,0,1,12.56-5.2m0-2.763A20.522,20.522,0,1,0,44.42,23.9,20.519,20.519,0,0,0,23.9,3.375Z",
    fill: "#9add3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosCloseCircleOutline);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-close-circle-outline.db6df63ee09c5bf8eb0008634cf52528.svg";
export { ForwardRef as ReactComponent };